import { graphql, useMutation } from "react-relay"
import { useChResendReferralLetterMutation as useChResendReferralLetterMutationType } from "@/modules/patients/detail/referral/ch/services/__generated__/useChResendReferralLetterMutation.graphql"

const resendReferralLetterMutation = graphql`
  mutation useChResendReferralLetterMutation($input: Ch_resendReferralLetterInput!) {
    ch_resendReferralLetter(input: $input) {
      ch_ReferralLetter {
        id
      }
      errors {
        ... on CareProviderHinEmailMissing {
          __typename
        }
        ... on ReferralLetterNotConcluded {
          __typename
        }
        ... on DocumentDoesNotExist {
          __typename
        }
      }
    }
  }
`

const useChResendReferralLetterMutation = () =>
  useMutation<useChResendReferralLetterMutationType>(resendReferralLetterMutation)

export { useChResendReferralLetterMutation }
